"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bucketStandardReadings = void 0;
const AutoBucketingHistoryStore_1 = require("../../model/constructs/AutoBucketingHistoryStore");
const lambda_1 = require("../lambda");
const types_1 = require("../time/Periodization/types");
const duration_1 = require("../time/duration");
const debug = lambda_1.NOT_CLOUD && false;
/** returns map of readings ( hourly, daily) by resolved entity sk.  */
const bucketStandardReadings = (input) => {
    const t0 = Date.now();
    const { readings, objectTypeId, readingsBucketStrategyMap, readingsRecentPeriodMs, } = input;
    const output = {
        readingBuckets: {},
        timings: { bucketing: 0 },
    };
    debug && console.log(`Bucketing readings input: `, { objectTypeId, readingsRecentPeriodMs, readingsBucketStrategyMap });
    if (readings) {
        const keys = readingsBucketStrategyMap ? Object.keys(readingsBucketStrategyMap) : null;
        const localBuckets = {};
        for (const reading of readings) {
            const { timestamp, id, ...others } = reading;
            const state = keys ? Object.fromEntries(Object.entries(others).filter(([k]) => keys.includes(k))) : others;
            const entitySk = `${objectTypeId}:${id}`;
            if (!localBuckets[entitySk]) {
                localBuckets[entitySk] = { daily: new AutoBucketingHistoryStore_1.AutoBucketHistory(), hourly: new AutoBucketingHistoryStore_1.AutoBucketHistory() };
                const thisBucket = localBuckets[entitySk];
                thisBucket.daily.timeBucketDef = {
                    unit: types_1.TimeBucketUnits.DAY,
                    width: 1,
                };
                thisBucket.daily.bucketStrategyMap = readingsBucketStrategyMap ?? {};
                thisBucket.hourly.timeBucketDef = {
                    unit: types_1.TimeBucketUnits.HOUR,
                    width: 1,
                };
                thisBucket.hourly.bucketStrategyMap = readingsBucketStrategyMap ?? {};
            }
            const stateSnapshot = {
                timestamp,
                state,
            };
            localBuckets[entitySk].daily.push(stateSnapshot);
            if (t0 - timestamp < readingsRecentPeriodMs) {
                localBuckets[entitySk].hourly.push(stateSnapshot);
                debug && console.log(`Pushed reading with timestamp ${timestamp} ( ${new Date(timestamp).toISOString()}) into hourly bucket`, stateSnapshot);
            }
            else {
                debug && console.log(`Not pushing reading with timestamp ${timestamp} ( ${new Date(timestamp).toISOString()}) into hourly bucket as it is outside of recent period`);
            }
        }
        output.readingBuckets = localBuckets;
    }
    const t1 = Date.now();
    debug && console.log(`Bucketed readings in ${(0, duration_1.getDurationSecondsStr)(t0)}`);
    output.timings.bucketing = t1 - t0;
    return output;
};
exports.bucketStandardReadings = bucketStandardReadings;
